import { cr, $subscriber, interact } from "fire-wind-water";
import { Touchs } from "./core/touchs";
import { column, wapWrap } from "./virtual/wap";

const scrolls = {
  x: 0,
  y: 0,
};

document.addEventListener("click", (e) => {
  scrolls.x = e.clientX;
  scrolls.y = e.clientY;
});
window.addEventListener("scroll", (ev) => {
  $subscriber.emit("hfs-window-scroll", ev);
});

window.addEventListener("mousewheel", (ev) => {
  $subscriber.emit("hfs-window-scroll", ev);
});

class Elem {
  setting: any = {
    elem: null,
  };
  touchs = new Touchs();
  model: any;
  value: any;
  virtual: any;
  items: any;
  dom: any;
  resetModel: any;
  constructor(sett) {
    cr.extend(true, this.setting, sett);
  }

  setValue(o) {
    this.model = o;
    this.value = {
      year: this.model.getFullYear(),
      month: this.model.getMonth() + 1,
      date: this.model.getDate(),
      hours: this.model.getHours(),
      minute: this.model.getMinutes(),
      second: this.model.getSeconds(),
    };
  }

  updateValue() {
    this.value.year = this.model.getFullYear();
    this.value.month = this.model.getMonth() + 1;
    this.value.date = this.model.getDate();
    this.value.hours = this.model.getHours();
    this.value.minute = this.model.getMinutes();
    this.value.second = this.model.getSeconds();
  }

  toDate(d?) {
    const o = cr.extend(true, this.value, d);
    return new Date(
      `${o.year}/${o.month}/${o.date} ${o.hours}:${o.minute}:${o.second}`
    );
  }

  render() {
    const oFragment = document.createDocumentFragment();
    const arr = this.createElem(this.virtual);
    cr.each(arr, (o) => {
      oFragment.appendChild(o);
    });
    let dom = document.querySelector(".picker-container");
    if (!dom) {
      const oF = document.createElement("div");
      oF.className =
        interact.isMobile === 1 ? "c-date-picker picker-wap" : "c-date-picker";
      const oZ = document.createElement("div");
      oZ.className = "picker-container";
      oF.appendChild(oZ);
      document.body.appendChild(oF);
      dom = oZ;
    }
    dom.innerHTML = "";
    dom.appendChild(oFragment);
    this.dom = dom;
    this.dom.parentNode.style.display = "block";
    this.dom.parentNode.onclick = () => {
      this.destroy();
    };
    this.parentEvent();
    // this.dom.parentNode.onmousewheel = this.dom.parentNode.ontouchmove = function(ev) {
    //   ev.preventDefault();
    //   ev.stopPropagation();
    // };
    this.items = dom.querySelectorAll(".picker-selection");
    if (this.items.length === 0) {
      this.items = dom.querySelectorAll(".month-item");
    }
    this.removeEventScroll();
    this.addEventScroll();
    this.scrollEvent();
  }

  createElem(a) {
    const arr = [];
    cr.each(a, (o) => {
      const el = document.createElement(o.h);
      el.className = o.c;
      if (o.html) {
        el.innerHTML = o.html;
      }
      if (o.event) {
        el.onclick = o.event;
      }
      if (o.id) {
        el.id = o.id;
      }
      if (o.s) {
        el.style = o.s;
      }
      if (o.e) {
        cr.each(o.e, (d) => {
          el.addEventListener(d.t, d.e, false);
        });
      }
      if (o.z) {
        const c = this.createElem(o.z);
        cr.each(c, (d) => {
          el.appendChild(d);
        });
      }
      arr.push(el);
    });
    return arr;
  }

  addEventScroll() {
    $subscriber.on("hfs-window-scroll", () => {
      this.scrollEvent();
    });
  }

  removeEventScroll() {
    $subscriber.off("hfs-window-scroll");
  }

  scrollEvent() {
    if (interact.isMobile === 1) {
      return;
    }
    const xy = {
      x: scrolls.x + "px",
      y: scrolls.y + "px",
    };
    if (this.setting.elem) {
      const rect = this.setting.elem.getBoundingClientRect();
      xy.x = rect.left + "px";
      xy.y = rect.top + "px";
    }
    this.dom.style.left = xy.x;
    this.dom.style.top = xy.y;
  }

  change(e?) {
    console.log(e);
  }

  destroy() {
    this.dom.innerHTML = "";
    this.dom.parentNode.style.display = "none";
    this.removeEventScroll();
  }

  prevent(ev) {
    ev.preventDefault();
    ev.stopPropagation();
  }

  parentEvent() {
    this.dom.parentNode.addEventListener("touchstart", this.prevent, false);
    this.dom.parentNode.addEventListener("touchmove", this.prevent, false);
  }

  renderWapItem(s, o) {
    const y = this.touchs.list[s].wap;
    const mm = o[s] || this.value[s];
    const ym =
      ["month", "hours", "minute", "second"].indexOf(s) !== -1 && mm < 10
        ? "0" + mm
        : mm;
    let index = y.indexOf(ym);
    let t = false;
    if (
      s === "date" &&
      index === -1 &&
      ym > this.touchs.list.date.wap[this.touchs.list.date.wap.length - 1]
    ) {
      index = this.touchs.list.date.wap.length;
      t = true;
    }
    this.touchs.setOptions(s, index, t);
  }

  resetWapRender(select) {
    const o = select || {};
    this.touchs.getMonth(
      o.year || this.value.year,
      o.month || this.value.month
    );
    this.setWapVirtual();
    this.render();
    cr.each(this.resetModel, (d) => {
      this.renderWapItem(d, o);
    });
  }

  wapVirtualItem(s, arr) {
    const y = this.touchs.list[s].wap;
    const year = column(
      y,
      (i) => {
        this.changeIndex(s, y[i]);
      },
      this.touchs.ids[s]
    );
    this.touchs.update(s, year.touch);
    if (arr) {
      arr.push(year.list);
    }
    return year;
  }

  setWapVirtual() {
    const arr = [];
    cr.each(this.resetModel, (d) => {
      this.wapVirtualItem(d, arr);
    });
    this.virtual = wapWrap(arr, this);
  }

  changeIndex(s, i) {
    this.touchs.changeIndex(s, i);
    if (s === "year" || s === "month") {
      const d = {
        year: this.touchs.select.year || this.value.year,
        month: this.touchs.select.month || this.value.month,
        date: this.touchs.select.date || this.value.date,
        hours: this.touchs.select.hours || this.value.hours,
        minute: this.touchs.select.minute || this.value.minute,
        second: this.touchs.select.second || this.value.second,
      };
      this.resetRender(d);
    }
  }

  resetRender(d?): void {
    console.log(d);
  }
}

export { Elem };
